import { render, staticRenderFns } from "./IndustryCreateV2.vue?vue&type=template&id=7888d959"
import script from "./IndustryCreateV2.vue?vue&type=script&lang=js"
export * from "./IndustryCreateV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports